<div class="position-relative">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-title"> {{ featureEdit ? 'Edit' : featureView ? 'View' :
        'Add' }}
        Feature Privilege</div>
    <!-- <ngx-loading [show]="loading"></ngx-loading> -->

    <form [formGroup]="featureForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="make-responsive">
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Menu</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="menu">
                        <mat-option *ngFor="let item of menuType; let i = index" [value]="item.tab" selected>
                            {{item.tab | titlecase}}
                        </mat-option>
                    </mat-select>
                    <ng-container *ngIf="formSubmitted && formValues['menu'].errors">
                        <mat-error *ngIf="formValues['menu'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Menu is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Feature Name</mat-label>
                    <input matInput formControlName="featureName">
                    <ng-container *ngIf="formSubmitted && formValues['featureName'].errors">
                        <mat-error *ngIf="formValues['featureName'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Feature Name is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field>
                    <mat-label>Feature Released On</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="featureReleasedOn" (click)="picker.open()" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <ng-container *ngIf="formSubmitted && formValues['featureReleasedOn'].errors">
                        <mat-error *ngIf="formValues['featureReleasedOn'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Feature Released On is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Feature Type</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="featureType">
                        <mat-option *ngFor="let item of type; let i = index" [value]="item.name" selected>
                            {{item.name | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="modal-form d-flex -text-area-field-height">
                <mat-form-field>
                    <mat-label>Feature Description</mat-label>
                    <textarea matInput cdkTextareaAutosize formControlName="featureDescription"
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
                    class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
        </div>
        <div class="btn-basket">
            <button mat-raised-button color="primary" data-dismiss="modal" type="button"
                (click)="closeModal()">Close</button>
            <button *ngIf="!featureView" mat-raised-button color="primary" type="submit"
                [disabled]="!featureForm.valid">
                {{ featureEdit ? 'Update' : 'Submit' }}
            </button>
        </div>
    </form>
</div>